export enum UpsellType {
  ITEM_BASED = 'Item Based',
  ORDER_BASED = 'Order Based',
  SIZE_BASED = 'Size Based',
  INGREDIENT = 'Ingredient',
  FEATURED_AREA = 'Featured Area',
  FEATURED_AREA_SPECIAL = 'Featured Area Special',
  EXTRA_INGREDIENT = 'Extra Ingredient',
}
